import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {Outlet, useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast'

const AdminLayout = () => {
    const user = useSelector((state) => state.loginUser.user)
    const navigate = useNavigate()
    
    useEffect(()=>{
        if(user&&user.role !== 'Admin') {
            navigate('/')
        } else {
          toast.success('Welcome Admin')
        }
    },[navigate, user])
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default AdminLayout
